import React, { useState } from '@wordpress/element';
import { BrowserRouter } from 'react-router-dom';
import StoreProvider from '../../store/store-provider';
import ArchiveList from '../../UI/archive-list';
import PortalProvider from '../../portal-provider';
import ListMap from '../../UI/list-map';
import Categories from '../../UI/categories';
import { findBlockByName } from '../../helpers/blockHelpers';

export const getImages = postItem => {
   //Find first occurance of image gallery block
    const imageGallery = findBlockByName('dalslandskanal-custom-blocks/image-gallery', postItem.blocks);
    const imageCarousel = findBlockByName('dalslandskanal-custom-blocks/image-slider', postItem.blocks);

    if (imageGallery) {
       return imageGallery.attrs.images;
    }

    if(imageCarousel) {
       return imageCarousel.attrs.images;
    }

    return null;
}

export const getText = (postItem, length = 100) => {
    if (!postItem || !postItem.blocks) {
        return null;
    }

    //Find first occurance of booking block
    const textBlock = findBlockByName('core/paragraph', postItem.blocks);
    if (!textBlock) {
        return null;
    }

    const regex = /(<([^>]+)>)/gi;
    const cleanText = textBlock.innerHTML.replace(regex, '');
    if (cleanText && cleanText.length > length) {
        return `${cleanText.substring(0, length)}...`;
    }

    return cleanText;
};

export const getCategory = (postItem, categories) => {
    if (!categories) {
        return null;
    }

    if (!postItem || !postItem.typ) {
        return null;
    }

    if (postItem.typ.length === 0) {
        return null;
    }

    const selectedCategories = categories.filter(f => postItem.typ.indexOf(f.id) > -1);
    return selectedCategories.map(m => m.name).join(' ');
};

const ExperienceLayout = props => {
    const [hoverId, setHoverId] = useState(null);

    return (
        <>
            <Categories {...props} />
            <ArchiveList {...props} hoverHandler={setHoverId} getImages={(post) => getImages(post)} getFactsText={(post) => <span className="card__category">{getCategory(post, props.categories)}</span>} getAltFacts={(post) => <span className="card__text" dangerouslySetInnerHTML={ { __html: getText(post) } }></span>}  />
            <PortalProvider elementId="map-list-root">
                <ListMap {...props} hoverId={hoverId} />
            </PortalProvider>
        </>
    );
};


const Experience = props => {
    return (
        <BrowserRouter>
            <StoreProvider {...props} type="experience" perPage="10" fetchCategories={true}>
                <ExperienceLayout />
            </StoreProvider>
        </BrowserRouter>
    );
};

export default Experience;